import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QuickStartGuideComponent } from './quick-start-guide.component';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		TranslateModule,
		CommonModule
	],
	declarations: [
		QuickStartGuideComponent
	],
	exports: [
		QuickStartGuideComponent
	]
})
export class QuickStartGuideModule {}
